import dayjs from 'dayjs';

export const isNotToday = (date: Date): boolean => {
  const today = dayjs().startOf('day');
  const inputDate = dayjs(date).startOf('day');

  return !today.isSame(inputDate);
};
